const ACTION = {
    UPDATE_LOGIN_ADDRESS: 'UPDATE_LOGIN_ADDRESS',
    UPDATE_LOGIN_ADDRESS_ERROR: 'UPDATE_LOGIN_ADDRESS_ERROR',
    UPDATE_LOGIN_ADDRESS_ERROR_BY_INDEX: 'UPDATE_LOGIN_ADDRESS_ERROR_BY_INDEX'
}

export default ACTION;